import { render, staticRenderFns } from "./assessment-results.view.vue?vue&type=template&id=2c2af712&scoped=true&"
import script from "./assessment-results.view.vue?vue&type=script&lang=ts&"
export * from "./assessment-results.view.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-results.view.vue?vue&type=style&index=0&id=2c2af712&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2af712",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
